// DEPENDENCIES
import React, { useState, useEffect, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

// CSS
import "./PendingAmendments.css";

// MSAL
import { useMsal } from "@azure/msal-react";

// API IMPORTS
import { getAPICall, postAPICall } from "../../../config/apiCalls";

// MUI COMPONENTS
import { CircularProgress } from "@mui/material";

// CUSTOM COMPONENTS
import PendingAmendmentCard from "./PendingAmendmentCard/PendingAmendmentCard";
import J2NoResultsFound from "../../Misc/J2NoResultsFound/J2NoResultsFound";

// CONTEXT
import { UserContext } from "../../../context/UserContext";

// CONSTANTS

// REACT COMPONENT
const PendingAmendments = () => {
	// MSAL
	const { instance, accounts } = useMsal();

	// STATES
	const [pendingAmendmentRecords, setPendingAmendmentRecords] = useState([]);

	const [isLoading, setIsLoading] = useState(false);

	// CONTEXT
	const employeeID = useContext(UserContext);

	// USE EFFECT
	useEffect(() => {
		postAPICall(instance, accounts[0], "/api/logs/access/add", {
			page_name: "Pending Amendments",
			employeeID: employeeID,
			notes: "Accessed the Pending Amendments page",
		}).catch(() => {});
	}, []);

	useEffect(() => {
		fetchPendingAmendments();
	}, []);

	// API METHODS
	const fetchPendingAmendments = async () => {
		setIsLoading(true);

		try {
			const res = await getAPICall(
				instance,
				accounts[0],
				"/api/jobs/pending/amendments/unsubmitted"
			);
			setPendingAmendmentRecords(res.data);
		} catch (error) {
			console.error(error);
		}

		setIsLoading(false);
	};

	return (
		<div className="PendingAmendments">
			<div className="pendingAmendmentsHeader">Pending Amendments</div>
			{isLoading && (
				<div className="pendingAmendmentsLoadingSpinner">
					<CircularProgress />
				</div>
			)}
			{!isLoading && (
				<div className="pendingAmendmentsContainer">
					{pendingAmendmentRecords.length > 0 ? (
						pendingAmendmentRecords.map((record) => (
							<RouterLink
								id="pendingJobCardLink"
								to={`/jobs/amendments/pending/${record.id}`}
								underline="none"
							>
								<PendingAmendmentCard amendment={record} />
							</RouterLink>
						))
					) : (
						<J2NoResultsFound />
					)}
				</div>
			)}
		</div>
	);
};

export default PendingAmendments;
